import React, { useEffect, useState } from 'react'
import { Alert } from 'antd'
import { RouteComponentProps } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { ApplicationState } from 'src/store'
import { getPartners } from 'src/core/store/ducks/partners/actions'
import { PageHeader, Button } from 'src/components/Ant'
import useDocumentTitle from 'src/hooks/use-document-title'

import Table from './components/table'

export default function Partners({ history }: RouteComponentProps<{}>) {
  useDocumentTitle('web.side.agencies.partners')

  const { agency_partners, partners } = useSelector(
    (state: ApplicationState) => ({
      agency_partners: state.agency_partners,
      partners: state.partners
    })
  )

  const [currentPage, setCurrentPage] = useState<number>(1)
  const [openSideModal, setOpenSideModal] = useState<boolean>(false)
  const [isNew, setIsNew] = useState<boolean>(true)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getPartners())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partners.sendPartnerLoading, agency_partners.sendAgencyPartnersLoading])

  return (
    <>
      <PageHeader
        onBack={() => {
          history.replace('/agencies/issuances')
        }}
        extra={[
          <Button
            key="common.actions.add"
            onClick={() => {
              setOpenSideModal(true)
              setIsNew(true)
            }}
            size="default"
            title="common.actions.add"
            type="primary"
          />
        ]}
        title="web.agencies.partners.title"
      />
      {partners.error && (
        <Alert message={partners.error} showIcon type="error" />
      )}
      <Table
        currentPage={currentPage}
        dataSource={partners.list.map(partner => ({
          ...partner,
          id: partner.partner_id,
          key: partner.partner_id,
          status: partner.active
        }))}
        isNew={isNew}
        loading={partners.loading}
        onChange={page => {
          dispatch(getPartners({ page }))
          setCurrentPage(page)
        }}
        openSideModal={openSideModal}
        responsePartner={partners.response}
        setOpenSideModal={setOpenSideModal}
        totalPages={partners.total_results}
      />
    </>
  )
}
